import LocalizedStrings from 'react-localization';

export default new LocalizedStrings({
    en: {
        newVersion: 'A new version has been found.',
        reloadPage: 'Click here to reload the page.',
    },
    es: {
        newVersion: 'Se ha encontrado una nueva versión.',
        reloadPage: 'Clique para recargar la página.',
    },
    de: {
        newVersion: 'Es wurde eine neue Version gefunden.',
        reloadPage: 'Klicken Sie hier, um die Seite neu zu laden.',
    },
    fr: {
        newVersion: 'Une nouvelle version a été trouvée.',
        reloadPage: 'Cliquez ici pour rafraîchir la page.',
    },
});
